import { render, staticRenderFns } from "./Rotate_Roaming.vue?vue&type=template&id=f1582678&scoped=true&"
import script from "./Rotate_Roaming.vue?vue&type=script&lang=js&"
export * from "./Rotate_Roaming.vue?vue&type=script&lang=js&"
import style0 from "./Rotate_Roaming.vue?vue&type=style&index=0&id=f1582678&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1582678",
  null
  
)

export default component.exports